import { Link, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="mx-auto flex w-full flex-1 flex-col items-center justify-center px-4 py-24 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-lg bg-accent-100 text-accent-800">
          <i className="ri-emotion-sad-line text-3xl" aria-hidden="true" />
        </span>
        <h1 className="mt-6 font-heading text-3xl font-black text-foreground-950 md:text-[40px]">
          这条瓜没了
        </h1>
        <p className="mt-3 text-sm text-foreground-500">
          你访问的页面不存在：<code className="text-foreground-800">{location.pathname}</code>
        </p>
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">
          可能链接拼写有误，或者内容已经被合并到其他条目。回到首页看看现在大家都在讨论什么。
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-5-line" aria-hidden="true" />
            返回首页
          </Link>
          <Link
            to="/topics"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-fire-line" aria-hidden="true" />
            看看热门瓜料
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}